import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function ViewTiled(): React.ReactElement {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect width="7.71426" height="7.71426" rx="1" />
      <rect y="10.2856" width="7.71426" height="7.71426" rx="1" />
      <rect x="10.2871" y="10.2856" width="7.71426" height="7.71426" rx="1" />
      <rect x="10.2871" width="7.71426" height="7.71426" rx="1" />
    </svg>
  );
}
